import { Alert, SimpleGrid, Stack } from '@mantine/core';
import { useDashboardSectionData } from '../hooks/useDashboardSectionData';
import { PerformanceCardSkeleton } from '../PerformanceCardSkeleton';
import { CompanyCertificationCard } from './cards/CompanyCertificationCard';
import { mapApiToArchData } from './helpers';
import { hasArchCompanyMetricsData } from './mapArchMetricsData';

const ARCH_GROUPS = new Set(['TU - ARCH', 'OSU']);

type ArchPerformanceMetricsProps = {
  selectedGroup: string | null;
};

export function ArchPerformanceMetrics({ selectedGroup }: ArchPerformanceMetricsProps) {
  const { mappedData, error, isLoading } = useDashboardSectionData({
    queryKey: 'arch',
    fallbackGroupId: 'TU - ARCH',
    selectedGroupOverride: selectedGroup,
    enabled: (group) => !!group && ARCH_GROUPS.has(group),
    mapData: mapApiToArchData,
  });

  const hasData = mappedData !== null && hasArchCompanyMetricsData(mappedData);

  return (
    <Stack spacing="lg">
      {error ? (
        <Alert color="yellow" variant="light">
          Unable to load dashboard API data.
        </Alert>
      ) : null}
      {!isLoading && !hasData ? (
        <Alert color="yellow" variant="light">
          No dashboard API data returned for this section.
        </Alert>
      ) : null}
      {isLoading && !hasData ? (
        <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 1200, cols: 1 }]}>
          <PerformanceCardSkeleton />
        </SimpleGrid>
      ) : null}
      {hasData && mappedData ? (
        <SimpleGrid cols={2} spacing="lg" breakpoints={[{ maxWidth: 1200, cols: 1 }]}>
          <CompanyCertificationCard data={mappedData} />
        </SimpleGrid>
      ) : null}
    </Stack>
  );
}
